<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import Dropdown from 'primevue/dropdown';

const { modeEvaluation, desactive, proposerModeCle } = defineProps({
    modeEvaluation: String,
    desactive: Boolean,
    proposerModeCle: Boolean
});

const emit = defineEmits(['update:modeEvaluation', 'modification']);

const modeEvaluationSelectionne = ref(null);

const modesEvaluationProposes = computed(() => {
    const modes = [
        {nom: 'SAISIE', libelle: 'Saisie'},
        {nom: 'CALCUL', libelle: 'Calcul'}
    ];
    if (proposerModeCle) {
        modes.push({nom: 'CLE', libelle: 'Clé'});
        modes.push({nom: 'CLE_AUTO', libelle: 'Clé (auto)'});
    }
    return modes;
});

onMounted(() => {
    modeEvaluationSelectionne.value = getModeEvaluation(modeEvaluation);
});

watch(() => modeEvaluation, (m) => {
    modeEvaluationSelectionne.value = getModeEvaluation(m);
});

function getModeEvaluation(modeEvaluation) {
    if (modesEvaluationProposes.value) {
        return modesEvaluationProposes.value.find(modeEval => modeEval.nom === modeEvaluation);
    } else {
        return null;
    }
}

function modifierModeEvaluation(m) {
    if (m.nom && m.nom !== modeEvaluation) {
        const nouveauModeEvaluation = m.nom;
        modeEvaluationSelectionne.value = getModeEvaluation(modeEvaluation);
        emit('update:modeEvaluation', nouveauModeEvaluation);
        emit('modification', nouveauModeEvaluation);
    }
}

</script>

<template>
    <Dropdown 
      v-model="modeEvaluationSelectionne" 
      :options="modesEvaluationProposes" 
      optionLabel="libelle"
      :disabled="desactive"
      placeholder="Indéfini"
      @change="modifierModeEvaluation($event.value)"/>
</template>

<style scoped>

</style>